import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const EmbeddedRockIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Embedded rock - rocks partially buried in ground */}
    <path d="M3 18h18" />
    <path d="M5 18c0-2 1-3 3-3s3 1 3 3" />
    <path d="M13 18c0-1.5 1-2.5 2.5-2.5s2.5 1 2.5 2.5" />
    <path d="M7 15l1-4 2 2" />
    <path d="M14 15.5l1-3 1.5 1.5" />
  </svg>
);
